module.exports = __webpack_public_path__ + "img/new_platform.e3e994fd.png";